import {RolandStructuredObject} from "./RolandStructuredObject.js";
import {copyBuffer} from "./CopyBuffer.js";

/**
 * This file contains all the classes for the structured arrays in a Roland file.
 */

/**
 * Base class for all structured arrays.
 */
class RolandStructuredArrayBase extends RolandStructuredObject {
    /**
     *
     * @param file
     * @param data
     * @param start
     * @param length
     * @param parent
     * @param childType
     */
    constructor(file, data,parent,start,length,childType) {
        super(file, data, parent, start, length);
        this.childType = childType;
    }

    /**
     * Type of child object
     * @type {typeof RolandStructuredObject}
     */
    childType=null;

    childObjectLength=undefined;
    childObjectCount=0;
    headerSize=0;

    toString() {
        return `${this.description} ${this.childType} ${this.childObjectCount} ${this.childObjectLength} ${this.headerSize}`;
    }   
}
/**
* An array of objects, variable in size with variable sized header
* Uint32 count
* Uint32 object size
* Uint32 this header size (at least 16)
* Uint32 random
*/
export class RolandStructuredVariableArray extends RolandStructuredArrayBase {
    /**
     *
     * @param file
     * @param data
     * @param start
     * @param length
     * @param parent
     * @param childType
     */
    constructor(file, data,parent,start,length,childType) {
        super(file,data,parent,start,length,childType);
    }

    nestedLoad(lc) {
        this.childObjectCount = this.getUint32(0);
        this.childObjectLength = this.getUint32(4 );
        this.ownedLength = this.headerSize = this.getUint32(8);
                
        this.loadArrayChildren(lc);

        if (this.childObjectCount>0 && this.childObjectLength>0)
            this.child = this.children[0];
    }

    /**
     * Load the children of the array.
     * @param lc
     * @returns address after last child
     */
    loadArrayChildren(lc) {
        let start = this.start + this.headerSize;

        if (this.childType !== undefined && this.childObjectLength > 0) {
            for (let i = 0; i < this.childObjectCount; i++) {
                let child = new this.childType(this.file, this.data, this, start, this.childObjectLength);
                child.childIndex = i;
                child.nestedLoad(lc);
                this.children.push(child);
                start += this.childObjectLength;
            }
        }
        return start;
    }

    /**
     * Add a child to the array.
     * @param child
     */
    addChild(child) {
        this.childObjectCount++;
        if ( this.getUint32(4)===0 && this.children.length==0) {
            this.setInt32(4, child.length);
            this.length += child.length;
        } else {
            this.length += this.childObjectLength;
            this.setInt32(0, this.childObjectCount);
        }
        this.children.push(child);
        // if its a new single item object and we have no length (i.e. empty USDa)

        if (this.children.length==1)
            this.child=child;
        else
            this.child=undefined;
    }

    /**
     * only for single array item
     * @param length
     */
    addSingleItemLength(length) {
        if (this.children.length!=1)
            throw "addSingleItemLength should only be called on a RolandStructuredArray with a single item";
        this.length+=length;
        this.setInt32(4,this.length-16);        // remove header
    }

    toString() {
        return `${this.description} ${this.childType} ${this.childObjectCount} ${this.childObjectLength} ${this.headerSize}`;
    }   
}

